module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-prior-payment-9b09d8cd1fd54f77f5e9eb4e927b3fdc.jpg";